import { render, staticRenderFns } from "./FeedbacksHome.vue?vue&type=template&id=5596f034&"
import script from "./FeedbacksHome.vue?vue&type=script&lang=js&"
export * from "./FeedbacksHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports